// F-148 §4.1 template v1. Header-only so that a downloaded template never imports example rows.

import { RECEIVING_CSV_COLUMNS } from './receiving-csv';
import { UTF8_BOM } from './receiving-normalize';

export const RECEIVING_CSV_TEMPLATE_VERSION = 1 as const;
export const RECEIVING_CSV_TEMPLATE_FILE_NAME = 'dukanti-receiving-template-v1.csv';
export const RECEIVING_CSV_TEMPLATE_MIME = 'text/csv;charset=utf-8';

/** UTF-8 BOM + the 12 template columns in canonical order + CRLF. */
export function buildReceivingCsvTemplate(): string {
  return `${UTF8_BOM}${RECEIVING_CSV_COLUMNS.join(',')}\r\n`;
}

/** Bytes for a Blob/download: BOM-prefixed UTF-8. */
export function buildReceivingCsvTemplateBytes(): Uint8Array {
  return new TextEncoder().encode(buildReceivingCsvTemplate());
}
